import Vue from 'vue'
import Router from 'vue-router'
import Inicio from './views/Inicio.vue'
import Pluviometros from './views/Pluviometros.vue'
import PluviometrosHoras from './views/PluviometrosHoras.vue'
import Mapa from './views/Mapa.vue'
import Hidrogramas from './views/Hidrogramas.vue'
import Gauge from './views/Gauge.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Incio',
      component: Inicio
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/pluviometros',
      name: 'Pluviometros',
      component: Pluviometros
    },
    {
      path: '/pluviometros_horas',
      name: 'PluviometrosHoras',
      component: PluviometrosHoras
    },
    {
      path: '/Mapa',
      name: 'Mapa',
      component: Mapa
    },
    {
      path: '/Hidrogramas',
      name: 'Hidrogramas',
      component: Hidrogramas
    },
    {
      path: '/strain_gauge',
      name: 'Gauge',
      component: Gauge
    }
  ]
})
